import React from 'react';
import { Badge } from '@one-thd/sui-atomic-components';
import { useViewChargedDetailsContext } from '../../../hooks/useContexts';

export const PoJobProjectNameBadges: React.FC = () => {
  const { chargeHistoryData } = useViewChargedDetailsContext();
  const { POJobName, projectName } = chargeHistoryData ?? {};

  if (!POJobName && !projectName) {
    return null;
  }

  return (
    <div className="sui-flex sui-gap-2 sui-pb-2">
      {POJobName && (
        <Badge variant="outline" color="primary">
          {POJobName}
        </Badge>
      )}
      {projectName && (
        <Badge variant="outline" color="primary">
          {projectName}
        </Badge>
      )}
    </div>
  );
};
